import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IStatusListsSectionFields } from '../../components/StatusListsSection/types';
import { getIsUserEssentialPlanOnly } from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import { StatusListsSection } from '../../components/StatusListsSection/StatusListsSection';

const mapStateToProps = (
    state: IApplicationState,
): IStatusListsSectionFields => {
    return {
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
    }
};

export const StatusListsSectionsHOC = connect(
    mapStateToProps,
    null
)(StatusListsSection);
